import { ATTRS, TAGS } from '../constants';
import { EntitiesManager } from '../entitiesManager';
import { Entity, ISOFileInformation } from '../types';
import { ProductEntity } from './Product';

export class ProductRelationEntity implements Entity {
  public static fromXML(
    xml: any,
    matchIDs: any,
    files: ISOFileInformation[],
    entitiesManager: EntitiesManager
  ) {
    const attrs = xml._attributes;
    const productEntity = entitiesManager.getEntityByIsoId<ProductEntity>(
      attrs[ATTRS.ProductRelation.ProductIdRef]
    );
    return {
      entity: new ProductRelationEntity(
        attrs[ATTRS.ProductRelation.QuantityValue],
        Number(productEntity)
      ),
    };
  }

  public type = TAGS.ProductRelation;

  constructor(
    public product: ProductEntity,
    public quantityValue: number
  ) {}

  public toXML(xmlId: string, entitiesManager: EntitiesManager) {
    const productIsoId = entitiesManager.registerEntity(this.product);
    return {
      _attributes: {
        [ATTRS.ProductRelation.ProductIdRef]: productIsoId,
        [ATTRS.ProductRelation.QuantityValue]: this.quantityValue,
      },
    };
  }
}
